import React from "react";
import { Container } from "react-bootstrap";
import Attachments from "../../../../elements/common/attachments/Attachments";
import Modal from "../../../../elements/Modal";
import { Typography } from "@mui/material";

const entityType = "TestStep";

const TestScriptsAttachments = ({
  show,
  handleClose,
  testStepId,
  selectedScript,
  fetchScripts
}) => {
  return (
    <Modal
      open={show}
      handleClose={handleClose}
      width="lg"
      modalTitle="Test Step Attachments"
    >
      <Container fluid className="px-0">
        <Typography variant="subtitle1" color="textSecondary">
          Step {selectedScript?.sNo}
        </Typography>
        <Attachments
          entityType={entityType}
          entityId={testStepId}
          showHeader={false}
          refreshData={fetchScripts}
        />
      </Container>
    </Modal>
  );
};

export default TestScriptsAttachments;
